import { FormattedMessage } from 'react-intl';

import { ConsentManagement } from './consent/ConsentManagement';

export const PreferencesView = () => {
    return (
        <div className="h-[calc(100vh-100px)]">
            <div className="mx-auto max-w-3xl px-l">
                <h1 className="mb-m text-3xl font-bold">
                    <FormattedMessage
                        id="_.credit_card.preferences.title"
                        defaultMessage="Card account preferences"
                    />
                </h1>
                <p className="text-primary-30 mb-l text-l">
                    <FormattedMessage
                        id="_.credit_card.preferences.description"
                        defaultMessage="You can manage your preferences specific to your iwoca credit card account here."
                    />
                </p>

                <ConsentManagement />
            </div>
        </div>
    );
};
